import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { EmailDeliveryComponent } from "./email-delivery/email-delivery.component";
import { EmailDeliveryStatusComponent } from "./email-delivery-status/email-delivery-status.component";

@NgModule({
    declarations: [
        EmailDeliveryComponent,
        EmailDeliveryStatusComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
    ]
})
export class TmTroubleshootModule{
}